/* eslint-disable */
import { RINGS_TYPE } from '@ringcentral-integration/commons/modules/RingtoneConfiguration/const';
export default {
  [RINGS_TYPE.Phone_Ring1]: 'Rufton 1',
  [RINGS_TYPE.Phone_Ring2]: 'Rufton 2',
  [RINGS_TYPE.Acoustic_Dreams]: 'Akustikträume',
  [RINGS_TYPE.Air_Raid]: 'Warnsignal',
  [RINGS_TYPE.Allusive]: 'Anspielung',
  [RINGS_TYPE.Attention]: 'Achtung',
  [RINGS_TYPE.Blub_Blub]: 'Blub Blub',
  [RINGS_TYPE.Buzzy]: 'Lebhaft',
  [RINGS_TYPE.Channel_Open]: 'Kanal offen',
  [RINGS_TYPE.Contemplation]: 'Reflexion',
  [RINGS_TYPE.Crystal_Ball]: 'Kristallkugel',
  [RINGS_TYPE.Disco]: 'Disko',
  [RINGS_TYPE.Door_Bell]: 'Türklingel',
  [RINGS_TYPE.Fairy]: 'Fee',
  [RINGS_TYPE.Fast_Bells]: 'Schnelle Glocken',
  [RINGS_TYPE.High_Gong]: 'Hoher Gong',
  [RINGS_TYPE.Immersion]: 'Immersion',
  [RINGS_TYPE.Indeed]: 'Wirklich',
  [RINGS_TYPE.Lazy_Day]: 'Entspannung',
  [RINGS_TYPE.Neural_Funk]: 'Neuron',
  [RINGS_TYPE.Nice]: 'Nett',
  [RINGS_TYPE.Ring]: 'Klingeln',
  [RINGS_TYPE.Ringing_Bells]: 'Glocken läuten',
  [RINGS_TYPE.Simple]: 'Einfach',
  [RINGS_TYPE.Soothing]: 'Beruhigend',
  [RINGS_TYPE.Sunshine]: 'Sonnenschein',
  [RINGS_TYPE.Off]: 'Aus',
  add: 'Hinzufügen',
  delete: 'Löschen',
  play: 'Wiedergeben',
  cancel: 'Abbrechen',
  confirmToDelete: '{name} löschen?',
} as const;

// @key: @#@"[RINGS_TYPE.Phone_Ring1]"@#@ @source: @#@"Phone Ring 1"@#@
// @key: @#@"[RINGS_TYPE.Phone_Ring2]"@#@ @source: @#@"Phone Ring 2"@#@
// @key: @#@"[RINGS_TYPE.Acoustic_Dreams]"@#@ @source: @#@"Acoustic Dreams"@#@
// @key: @#@"[RINGS_TYPE.Air_Raid]"@#@ @source: @#@"Air Raid"@#@
// @key: @#@"[RINGS_TYPE.Allusive]"@#@ @source: @#@"Allusive"@#@
// @key: @#@"[RINGS_TYPE.Attention]"@#@ @source: @#@"Attention"@#@
// @key: @#@"[RINGS_TYPE.Blub_Blub]"@#@ @source: @#@"Blub Blub"@#@
// @key: @#@"[RINGS_TYPE.Buzzy]"@#@ @source: @#@"Buzzy"@#@
// @key: @#@"[RINGS_TYPE.Channel_Open]"@#@ @source: @#@"Channel Open"@#@
// @key: @#@"[RINGS_TYPE.Contemplation]"@#@ @source: @#@"Contemplation"@#@
// @key: @#@"[RINGS_TYPE.Crystal_Ball]"@#@ @source: @#@"Crystal Ball"@#@
// @key: @#@"[RINGS_TYPE.Disco]"@#@ @source: @#@"Disco"@#@
// @key: @#@"[RINGS_TYPE.Door_Bell]"@#@ @source: @#@"Door Bell"@#@
// @key: @#@"[RINGS_TYPE.Fairy]"@#@ @source: @#@"Fairy"@#@
// @key: @#@"[RINGS_TYPE.Fast_Bells]"@#@ @source: @#@"Fast Bells"@#@
// @key: @#@"[RINGS_TYPE.High_Gong]"@#@ @source: @#@"High Gong"@#@
// @key: @#@"[RINGS_TYPE.Immersion]"@#@ @source: @#@"Immersion"@#@
// @key: @#@"[RINGS_TYPE.Indeed]"@#@ @source: @#@"Indeed"@#@
// @key: @#@"[RINGS_TYPE.Lazy_Day]"@#@ @source: @#@"Lazy Day"@#@
// @key: @#@"[RINGS_TYPE.Neural_Funk]"@#@ @source: @#@"Neural Funk"@#@
// @key: @#@"[RINGS_TYPE.Nice]"@#@ @source: @#@"Nice"@#@
// @key: @#@"[RINGS_TYPE.Ring]"@#@ @source: @#@"Ring"@#@
// @key: @#@"[RINGS_TYPE.Ringing_Bells]"@#@ @source: @#@"Ringing Bells"@#@
// @key: @#@"[RINGS_TYPE.Simple]"@#@ @source: @#@"Simple"@#@
// @key: @#@"[RINGS_TYPE.Soothing]"@#@ @source: @#@"Soothing"@#@
// @key: @#@"[RINGS_TYPE.Sunshine]"@#@ @source: @#@"Sunshine"@#@
// @key: @#@"[RINGS_TYPE.Off]"@#@ @source: @#@"Off"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"delete"@#@ @source: @#@"Delete"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirmToDelete"@#@ @source: @#@"Delete {name}?"@#@
